export const HISTORIC_WEATHER = 'HistoricWeather';
